/* import __COLOCATED_TEMPLATE__ from './reviewable-tags.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-tags.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));